import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleChevronRight,
  faCircleChevronLeft
} from '@fortawesome/free-solid-svg-icons';

import './styles.carousel.scss';

export const Carousel = (props) => {
  const { children, show, infiniteLoop } = props;

  const childrenSize = children.length
    ? children.length
    : children.props.array.length;

  const [currentIndex, setCurrentIndex] = useState(infiniteLoop ? show : 0);
  const [length, setLength] = useState(childrenSize);

  const [isRepeating, setIsRepeating] = useState(
    infiniteLoop && childrenSize > show
  );
  const [transitionEnabled, setTransitionEnabled] = useState(true);

  // Set the length to match current children from props
  useEffect(() => {
    setLength(childrenSize);
    setIsRepeating(infiniteLoop && childrenSize > show);
  }, [children, infiniteLoop, show]);

  useEffect(() => {
    if (isRepeating) {
      if (currentIndex === show || currentIndex === length) {
        setTransitionEnabled(true);
      }
    }
  }, [currentIndex, isRepeating, show, length]);

  useEffect(() => {
    setCurrentIndex(infiniteLoop ? show : 0);
  }, [childrenSize]);

  const next = () => {
    if (isRepeating || currentIndex < length - show) {
      setCurrentIndex((prevState) => prevState + 1);
    }
  };

  const prev = () => {
    if (isRepeating || currentIndex > 0) {
      setCurrentIndex((prevState) => prevState - 1);
    }
  };

  const handleTransitionEnd = () => {
    if (isRepeating) {
      if (currentIndex === 0) {
        setTransitionEnabled(false);
        setCurrentIndex(length);
      } else if (currentIndex === length + show) {
        setTransitionEnabled(false);
        setCurrentIndex(show);
      }
    }
  };

  const renderExtraPrev = () => {
    const output = [];
    for (let index = 0; index < show; index++) {
      output.push(children[length - 1 - index]);
    }
    output.reverse();
    return output;
  };

  const renderExtraNext = () => {
    const output = [];
    for (let index = 0; index < show; index++) {
      output.push(children[index]);
    }
    return output;
  };

  return (
    <div className="carousel-container">
      <div className="carousel-wrapper">
        {/* left arrow button */}
        {(isRepeating || currentIndex > 0) && (
          <button onClick={prev} className="left-arrow">
            <FontAwesomeIcon icon={faCircleChevronLeft} />
          </button>
        )}
        <div className="carousel-content-wrapper">
          <div
            className={`carousel-content show-${show}`}
            style={{
              transform: `translateX(-${currentIndex * (100 / show)}%)`,
              transition: !transitionEnabled ? 'none' : undefined
            }}
            onTransitionEnd={() => handleTransitionEnd()}
          >
            {length > show && isRepeating && renderExtraPrev()}
            {children}
            {length > show && isRepeating && renderExtraNext()}
          </div>
        </div>
        {/* right arrow button */}
        {(isRepeating || currentIndex < length - show) && (
          <button onClick={next} className="right-arrow">
            <FontAwesomeIcon icon={faCircleChevronRight} />
          </button>
        )}
      </div>
    </div>
  );
};

Carousel.propTypes = {
  children: PropTypes.any,
  show: PropTypes.number,
  infiniteLoop: PropTypes.bool
};
